import { z } from "zod";

export const classAvatarSchema = z.object({
  color_hex: z.string(),
  id: z.number(),
  name: z.string(),
  url: z.string(),
});
